// extracted by mini-css-extract-plugin
module.exports = {"item":"item--2smTgCv86A"};